import { useState, useEffect } from "@discovery/common-dplus/lib/hooks";
import { useUser } from "../../../utils/hooks/useUser";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Favorites from "@discovery/sonic-api-ng/lib/api/users/favorites";
import { pushFavoriteOrWatchListEvents } from "@discovery/common-dplus/lib/adobe";
import { navigateTo } from "../../../utils/common";
import { Icon, Icons } from "../../atoms/icon";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import * as styles from "../like-watch-later/styles.css";
import Strings from "../../../utils/hardcoded.json";
import { Toast } from "../toast";
import { cn } from "@discovery/classnames";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
import { blueshiftFavorite } from "@discovery/common-dplus/lib/blueshift";
export const favorite = (userId, isFavorite, read, id, category, setToastMsg, route, temp, name, contentCategory) => {
    if (!isFavorite) {
        const postRequest = Favorites.Endpoints.deleteFavorite(id, `${category}`);
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
                () => {
                    setToastMsg &&
                        setToastMsg(Strings.ERROR_SAVING_PREFERENCE, false);
                };
            }, () => {
                temp && localStorage.setItem("tempFavId", id);
                setToastMsg &&
                    setToastMsg(!isFavorite
                        ? Strings.REMOVE_FROM_FAVOURITES
                        : Strings.ADD_TO_FAVOURITES, true);
                blueshiftFavorite(userId, id, "delete", category, name ? name : "", contentCategory);
                pushFavoriteOrWatchListEvents("add to favorites", "favorites", window.location.href, window.location.origin + route);
            }));
    }
    else {
        const postRequest = Favorites.Endpoints.postFavorite(id, `${category}`);
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
                () => {
                    setToastMsg &&
                        setToastMsg(Strings.ERROR_SAVING_PREFERENCE, false);
                };
            }, () => {
                temp && localStorage.setItem("tempFavId", id);
                setToastMsg &&
                    setToastMsg(!isFavorite
                        ? Strings.REMOVE_FROM_FAVOURITES
                        : Strings.ADD_TO_FAVOURITES, true);
                pushFavoriteOrWatchListEvents("add to favorites", "favorites", window.location.href, window.location.origin + route);
                blueshiftFavorite(userId, id, "add", category, name ? name : "", contentCategory);
            }));
    }
};
export const Favorite = ({ id, type, isFavorite, isShow, isShowHorizontal, anonymous, webAuthUrl, read, isFavPage, route, removeFromfavorites, name, showGenre, contentGenre, }) => {
    const [isToastMsg, showMsg] = useState(false);
    const [toastMsg, setToastMessage] = useState("");
    const [isFav, toggleFav] = useState(false);
    const { userId } = useUser();
    const toastHandler = (message) => {
        setToastMessage(message);
        showMsg(true);
        setTimeout(() => {
            showMsg(false);
        }, 2000);
    };
    useEffect(() => {
        toggleFav(isFavorite);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFavorite]);
    const toggleToast = () => {
        showMsg(false);
    };
    const removeFromFavorites = (id, videoType) => {
        const postRequest = Favorites.Endpoints.deleteFavorite(id, `${videoType}`);
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
                () => setToastMessage(Strings.ERROR_SAVING_PREFERENCE);
            }, () => {
                toastHandler("Removed from your Favourites");
                removeFromfavorites && removeFromfavorites(id);
                pushFavoriteOrWatchListEvents("remove favorites", "remove favorites", window.location.href, window.location.origin + route);
            }));
    };
    const toggleFavorite = (isFav, id) => {
        const videoType = type === "show" || type === "shows" || type === "Show" ? type : "video"; //TODO: rename "show" to single convention
        const authUrl = webAuthUrl + "/login";
        const contentCategory = showGenre ? M.fromMaybe(showGenre, "") : "";
        if (id) {
            if (anonymous) {
                localStorage.setItem("favId", id);
                localStorage.setItem("favType", type);
                localStorage.setItem("tempFavId", id);
                const authRedirect = setAuthRedirectUrl(window.location.pathname);
                navigateTo(`${authUrl}?returnUrl=${authRedirect}`);
            }
            else {
                localStorage.removeItem("tempFavId");
                !isFavPage && toggleFav(!isFav);
                isFavPage
                    ? removeFromFavorites(id, videoType)
                    : read &&
                        favorite(userId, !isFav, read, id, videoType, toastHandler, route, false, name, contentGenre ? M.fromMaybe(contentGenre, [""]) : [contentCategory]);
            }
        }
    };
    const shortsLike = isFav
        ? cn(styles.linkWrapperForShorts, styles.favWrapper, {
            [styles.horizontalLabel]: isShowHorizontal === true,
        })
        : cn(styles.linkWrapperForShortsLike, {
            [styles.horizontalLabel]: isShowHorizontal === true,
        });
    const tempFavId = localStorage.getItem("tempFavId");
    const likeId = localStorage.getItem("favId");
    const favId = likeId ? likeId : tempFavId;
    const isFavId = favId === id && !anonymous ? true : isFav;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: shortsLike, onClick: (event) => {
                toggleFavorite(isFavId, id);
                event.stopPropagation();
                event.preventDefault();
            }, id: isFavId ? "favorite" : "unFavorite" },
            React.createElement(Icon, { type: isFavId ? Icons.Favorite : Icons.UnFavorite, className: styles.linkIcons, color: "white" }),
            isShow && (React.createElement(Typography, { classNameM: M.of(cn(styles.linkLabels, {
                    [styles.linkIconActive]: isFav,
                    [styles.horizontalLabel]: isShowHorizontal === true,
                })), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.FAVORITES)))),
        React.createElement("div", { className: styles.toastMsgStyle }, isToastMsg ? (React.createElement(Toast, { toastMsg: toastMsg, successFlag: true, onClick: toggleToast })) : null)));
};

